import { useState } from "react";
import axios from "axios";

const VoicePlayer = ({ placeName, style }) => {
  const [audioUrl, setAudioUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const handleGenerateVoice = async () => {
    try {
      setLoading(true);
      setAudioUrl(null);

      // Backend endpoint çağrısı
      const response = await axios.get(
        `${API_URL}/api/gcloud-voice/${placeName}/${style}`,
        {
          responseType: "blob", // MP3 binary dönüyor
        }
      );

      // MP3 blob’dan URL oluştur
      const url = URL.createObjectURL(
        new Blob([response.data], { type: "audio/mpeg" })
      );
      setAudioUrl(url);
    } catch (err) {
      console.error("Ses oluşturulurken hata:", err);
      alert("Ses oluşturulamadı. Tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-4 bg-white rounded-xl shadow-lg w-full max-w-md space-y-4">
      {/* Butonu sadece ses oluşturulmamışken göster */}
      {!audioUrl && (
        <button
          onClick={handleGenerateVoice}
          disabled={loading}
          className="px-4 py-2 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 disabled:bg-gray-400 transition-colors w-full"
        >
          {loading ? "Ses oluşturuluyor..." : "Ses Oluştur ve Dinle"}
        </button>
      )}

      {/* Ses hazır olunca göster */}
      {audioUrl && (
        <div className="space-y-2">
          <p className="text-gray-700 font-medium">Ses hazır 🎧</p>
          <audio controls src={audioUrl} className="w-full">
            Tarayıcınız audio etiketini desteklemiyor.
          </audio>
        </div>
      )}
    </div>
  );
};

export default VoicePlayer;
